var res = [{"key":"10/11","value":"74%"},{"key":"11/12","value":"74%"},{"key":"12/13","value":"76%"},{"key":"13/14","value":"81%"},{"key":"14/15","value":"84%"},{"key":"15/16","value":"85%"},{"key":"16/17","value":"86%"}];res.columns = ["key","value"];module.exports = res;


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/customer-satisfaction.csv
// module id = 608
// module chunks = 0